import styles from "./CenteredFallback.module.scss"

const CenteredFallback = ({ children }) => {
  return <div className={styles.centeredFallback}>{children}</div>
}

export default CenteredFallback
